export default __webpack_public_path__ + "static/media/font.225a3715.woff";